import { ArticleResolution } from '@wix/answers-api';
import { Tag, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Long from 'long';
import React, { FC } from 'react';

import { isNumber } from '../../../../util/guards';
import { HelpCenterArticle } from '../../types';
import s from './styles.scss';

export interface ResolutionTagProps {
  article: HelpCenterArticle;
}

const getQuarter = (eta: Long | number) => {
  const etaNumber = isNumber(eta) ? eta : new Long(eta.low, eta.high).toNumber();
  const etaDate = new Date(etaNumber);
  const month = etaDate.getUTCMonth();
  const year = etaDate.getUTCFullYear();
  const quarter = Math.ceil((month + 1) / 3);

  return {
    quarter,
    year,
  };
};

export const ResolutionEtaTag: FC<ResolutionTagProps> = ({ article }) => {
  const { t } = useTranslation();
  const { resolution, resolutionEta } = article;

  return resolutionEta && resolution !== ArticleResolution.RELEASED ? (
    <Tooltip
      size="small"
      content={t(`article_resolution_tooltip_eta_${getQuarter(resolutionEta).quarter}`, {
        year: `${getQuarter(resolutionEta).year}`,
      })}
    >
      <Tag size="small" className={`${s.statusTag} ${s.eta}`} id="eta" theme="standard" removable={false}>
        <Text size="small">{t('article_eta', getQuarter(resolutionEta))}</Text>
      </Tag>
    </Tooltip>
  ) : null;
};
